import React from 'react';
import WelcomeSheet from '@/modules/topic/welcome/WelcomeSheet';
import ShareIntroBlock from '@/modules/topic/welcome/ShareIntroBlock';
import HomeInstallNudgeBlock from '@/modules/topic/welcome/HomeInstallNudgeBlock';
import HomeInstallDetailBlocks from '@/modules/topic/welcome/HomeInstallDetailBlocks';
import ResharePromptBlock from '@/modules/topic/welcome/ResharePromptBlock';
import WelcomeButton from '@/modules/topic/welcome/WelcomeButton';
import { useHomeInstallNudge } from '@/modules/topic/welcome/useHomeInstallNudge';
import type { TopicWelcomeProps } from '@/modules/topic/welcome/types';

/**
 * Beautification welcome sheet — the standard layout: who shared the beautification project,
 * the Home-Screen install nudge, the button that passes it on, and the button
 * into the topic. Composed inline from the shared welcome sections (rather than
 * delegating to one shared sheet) so the beautification project welcome can diverge from the
 * other types over time.
 */
const WelcomeInterstitial: React.FC<TopicWelcomeProps> = ({
  isOpen,
  topicType,
  senderName,
  onDismiss,
  hideShareIntro = false,
  isUpdate = false,
  topic,
  topicId,
  legId,
  receivedUpdateReshare = null,
}) => {
  const homeInstall = useHomeInstallNudge(isOpen);

  return (
    <WelcomeSheet
      isOpen={isOpen}
      onDismiss={onDismiss}
      compact={!homeInstall.show}
    >
      {!hideShareIntro && (
        <ShareIntroBlock
          topicType={topicType}
          senderName={senderName}
          isUpdate={isUpdate}
        />
      )}

      {homeInstall.show && (
        <HomeInstallNudgeBlock
          dismissed={homeInstall.dismissed}
          onDismissedChange={homeInstall.onDismissedChange}
        />
      )}

      {topic && topicId && (
        <ResharePromptBlock
          topic={topic}
          topicId={topicId}
          previousLegId={legId}
          receivedUpdateReshare={receivedUpdateReshare}
          onDismiss={onDismiss}
        />
      )}

      <WelcomeButton onClick={onDismiss} />

      {homeInstall.show && <HomeInstallDetailBlocks />}
    </WelcomeSheet>
  );
};

export default WelcomeInterstitial;
